import {
  CLEAR_CLOUDFLARE_TUNEL,
  UPDATE_ETAPAS_TUNNEL_INIT,
  UPDATE_ETAPAS_TUNNEL_SUCCESS,
  CONFIGURE_ROTA_TUNNEL_INIT,
  CONFIGURE_ROTA_TUNNEL_SUCCESS,
  CREATE_TUNNEL_NAME_INIT,
  CREATE_TUNNEL_NAME_SUCCESS,
  ERROR_CLOUDFLARE_TUNEL,
  REFRESH_TUNNEL_INIT,
  REFRESH_TUNNEL_SUCCESS,
  VALIDATE_CONNECTOR_INIT,
  VALIDATE_CONNECTOR_SUCCESS,
  DELETE_TUNNEL_INIT,
  DELETE_TUNNEL_SUCCESS
} from '../actionTypes';

export const createNameTunelInit = (data) => ({
  type: CREATE_TUNNEL_NAME_INIT,
  payload: data
});

export const createNameTunelSuccess = (data) => {
  return {
    type: CREATE_TUNNEL_NAME_SUCCESS,
    payload: data
  };
};

export const refreshTunelInit = (data) => ({
  type: REFRESH_TUNNEL_INIT,
  payload: data
});

export const refreshTunelSuccess = (data) => ({
  type: REFRESH_TUNNEL_SUCCESS,
  payload: data
});

export const validateConnectorInit = (data) => ({
  type: VALIDATE_CONNECTOR_INIT,
  payload: data
});

export const validateConnectorSuccess = (data) => ({
  type: VALIDATE_CONNECTOR_SUCCESS,
  payload: data
});

export const configureRotaTunnelInit = (data) => ({
  type: CONFIGURE_ROTA_TUNNEL_INIT,
  payload: data
});

export const configureRotaTunnelSuccess = (data) => ({
  type: CONFIGURE_ROTA_TUNNEL_SUCCESS,
  payload: data
});

export const updateEtapasTunnelInit = (data) => ({
  type: UPDATE_ETAPAS_TUNNEL_INIT,
  payload: data
});

export const updateEtapasTunnelSuccess = (data) => ({
  type: UPDATE_ETAPAS_TUNNEL_SUCCESS,
  payload: data
});

export const deleteTunnelInit = (data) => ({
  type: DELETE_TUNNEL_INIT,
  payload: data
});

export const deleteTunnelSuccess = (data) => ({
  type: DELETE_TUNNEL_SUCCESS,
  payload: data
});

export const errorCloudFlareTunelMsg = (data) => ({
  type: ERROR_CLOUDFLARE_TUNEL,
  payload: data
});

export const clearCloudFlareTunel = (data) => ({
  type: CLEAR_CLOUDFLARE_TUNEL,
  payload: data
});
